export function formatDuration(minutes) {
  const safeMinutes = Math.max(0, Number(minutes) || 0);
  const hours = Math.floor(safeMinutes / 60);
  const remainder = safeMinutes % 60;
  if (!hours) return `${remainder} min`;
  return remainder ? `${hours} h ${remainder} min` : `${hours} h`;
}

export function formatActiveTeacherCount(count) {
  const safeCount = Math.max(0, Number(count) || 0);
  return `${safeCount} active ${safeCount === 1 ? 'teacher' : 'teachers'}`;
}

export function sortTeachersByAvailability(teachers = []) {
  return [...teachers].sort((left, right) => (
    (Number(right.available_minutes) || 0) - (Number(left.available_minutes) || 0)
    || String(left.teacher_name || '').localeCompare(String(right.teacher_name || ''))
  ));
}

export function buildCapacityQuery({ teacherId, subjectId, grade } = {}) {
  const params = new URLSearchParams();
  if (teacherId) params.set('teacher_id', teacherId);
  if (subjectId) params.set('subject_id', subjectId);
  if (grade) params.set('grade', grade);
  const query = params.toString();
  return query ? `?${query}` : '';
}
